var takeover = {
	$this: $('.js-take-over'),
};

const $btnMenu = $('.js-menu-btn'),
		$closeBtn = $('.js-close-btn');

function open () {
	takeover.$this.css('visibility', 'visible');
	setTimeout(function () {
		takeover.$this.addClass('show');
	}, 10);
	$closeBtn.addClass('show');

	setTimeout(function () {
		$('body').css('overflow', 'hidden');
	}, 100);

	if($(window).width() < 768){
		$('.sitewide__logo').prependTo('.takeover-content .grid');
	}
}

function close () {
	$closeBtn.removeClass('show');
	takeover.$this.removeClass('show');
	setTimeout(function () {
		takeover.$this.removeAttr('style');
	}, 300);
	$('body').css('overflow-y', 'scroll');
}

takeover.init = function () {
	$btnMenu.on('click', function (e) {
		e.preventDefault();
		takeover.$this = $('.js-take-over');
		open();
	});

	$closeBtn.on('click', function (e) {
		e.preventDefault();
		close();
	});

};

export { takeover };
